import { render, staticRenderFns } from "./DialogPrivateSetting.pug?vue&type=template&id=ca5d6b66&lang=pug&"
import script from "./DialogPrivateSetting.vue?vue&type=script&lang=js&"
export * from "./DialogPrivateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports